import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';
import { chatKeyboardFocusVisible } from '../../styles/chatFocus';

export const Container = styled.div`
  position: relative;
  width: 100%;
`;

export const Viewport = styled.div<{ $bleedLeft?: number }>`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
  scroll-snap-type: x mandatory;
  ${({ $bleedLeft }) => $bleedLeft && `scroll-padding-inline-start: ${$bleedLeft}px;`}

  /* Desktop (992px+): reset scroll-padding when sidebar is visible */
  @media ${baseVariables.mediaQuery.lg} {
    scroll-padding-inline-start: 0;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Rail = styled.div<{ $gap: number }>`
  display: flex;
  gap: ${({ $gap }) => `${$gap}px`};
`;

export const BleedSpacer = styled.div<{ $width: number }>`
  flex: 0 0 ${({ $width }) => $width}px;
  min-width: ${({ $width }) => $width}px;
`;

export const Slide = styled.div<{
  $isSingle: boolean;
  $gap: number;
  $slidesPerViewMobile: number;
  $slidesPerViewTablet: number;
  $slidesPerViewDesktop: number;
  $fixedSlideWidth?: number;
}>`
  ${({ $fixedSlideWidth, $isSingle, $slidesPerViewMobile, $gap }) =>
    $fixedSlideWidth
      ? `flex: 0 0 ${$fixedSlideWidth}px;`
      : `flex: 0 0 ${
          $isSingle
            ? '100%'
            : `calc((100% - ${(Math.max($slidesPerViewMobile - 1, 0) * $gap).toFixed(2)}px) / ${$slidesPerViewMobile})`
        };`}
  scroll-snap-align: start;
  padding: var(--general-spacer-02, 8px) 0;
  @media (min-width: 768px) {
    ${({ $fixedSlideWidth, $isSingle, $slidesPerViewTablet, $gap }) =>
      $fixedSlideWidth
        ? `flex: 0 0 ${$fixedSlideWidth}px;`
        : `flex: 0 0 ${
            $isSingle
              ? '100%'
              : `calc((100% - ${(Math.max($slidesPerViewTablet - 1, 0) * $gap).toFixed(
                  2
                )}px) / ${$slidesPerViewTablet})`
          };`}
  }

  @media (min-width: 1024px) {
    ${({ $fixedSlideWidth, $isSingle, $slidesPerViewDesktop, $gap }) =>
      $fixedSlideWidth
        ? `flex: 0 0 ${$fixedSlideWidth}px;`
        : `flex: 0 0 ${
            $isSingle
              ? '100%'
              : `calc((100% - ${(Math.max($slidesPerViewDesktop - 1, 0) * $gap).toFixed(
                  2
                )}px) / ${$slidesPerViewDesktop})`
          };`}
  }
`;

export const ArrowButton = styled.button<{ $direction?: 'left' | 'right' }>`
  position: absolute;
  ${({ $direction }) => ($direction === 'left' ? 'left: 0;' : 'right: 0;')}
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 100px;
  border: none;
  background: rgba(255, 255, 255, 0.54);
  backdrop-filter: blur(4px);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease;

  @media (min-width: 768px) {
    display: flex;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.8);
  }

  ${chatKeyboardFocusVisible}

  .icon-arrow-right,
  .icon-arrow-left {
    font-size: 24px;
    color: #1c1c1c;
  }
`;
